import React, { useEffect, useState } from 'react';
import { Button, Stack } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { API } from '../data/API/API';
import EmailTemplateTable from '../components/EmailTemplateTable/EmailTemplateTable';
import './EmailTemplatePage.scss';

interface EmailTemplate {
    id: number;
    templateName: string;
    header: string;
    body: string;
    active: boolean;
}

const EmailTemplatePage: React.FC = () => {
    const [isLoading, setLoading] = useState(true);
    const [templates, setTemplates] = useState<EmailTemplate[]>([]);
    const [errorMsg, setErrorMsg] = useState<string | null>(null);
    const [successMsg, setSuccessMsg] = useState<string | null>(null);
    const navigate = useNavigate();

    // Fetch templates on page load
    useEffect(() => {
        const fetchTemplates = async () => {
            try {
                const fetchedTemplates = await API.EmailTemplates.GetAllEmailTemplates();
                setTemplates(fetchedTemplates);
                setLoading(false);
            } catch (error) {
                setErrorMsg("Misslyckades med att hämta e-postmallar.");
                setLoading(false);
            }
        };
        fetchTemplates();
    }, []);

    // Handle delete logic
    const handleDelete = async (id: number) => {
        if (window.confirm('Är du säker på att du vill ta bort denna mall?')) {
            try {
                const response = await API.EmailTemplates.DeleteEmailTemplate(id);

                // Check if the response status is OK
                if (response.ok) {
                    setTemplates(templates.filter(template => template.id !== id));
                    setSuccessMsg("E-postmallen togs bort!");
                    setErrorMsg(null);  // Clear any previous error messages

                    // Hide the success message after 3 seconds
                    setTimeout(() => setSuccessMsg(null), 3000);
                } else {
                    throw new Error('Failed to delete the template.');
                }
            } catch (error) {
                // Show error message and keep the template in the table
                setErrorMsg("Misslyckades med att ta bort e-postmallen.");
                setSuccessMsg(null);  // Clear success message in case of failure
            }
        }
    };

    return (
        <div className="email-template-page">
            <div className="email-template-header-row">
                <h1 className="email-template-header">Hantera e-postmallar</h1>
                <button
                    className="btn"
                    onClick={() => navigate('/email-templates/create')}
                >
                    Skapa ny mall
                </button>
            </div>


            {/* Error Message */}
            {errorMsg && <div className="template-error-message">{errorMsg}</div>}

            {/* Success Message */}
            {successMsg && <div className="template-success-message">{successMsg}</div>}

            <div className="template-table-wrapper">
                <EmailTemplateTable
                    templates={templates}
                    isLoading={isLoading}
                    onDelete={handleDelete}
                />
            </div>
        </div>
    );
};

export default EmailTemplatePage;